// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__1jqil","buscador":"Formulario_buscador__5BI-F","btn_block":"Formulario_btn_block__2RHke"};